module.exports = __webpack_public_path__ + "07_mustache_brown.f799c605.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/07_mustache_brown.png
// module id = OVV6
// module chunks = 0